import { STRINGS } from '../content/strings'
import { ROUTES } from './routes'

type NavigationItem = {
  name: string
  route: string
  subPage?: NavigationItem
}

export const NavigationItems: Array<NavigationItem> = [
  {
    name: STRINGS.navigationItems.start,
    route: ROUTES.start,
    subPage: {
      name: STRINGS.navigationItems.matchcard,
      route: ROUTES.matchcard,
    },
  },
  {
    name: STRINGS.navigationItems.roster,
    route: ROUTES.roster,
    subPage: {
      name: STRINGS.navigationItems.wrestler,
      route: ROUTES.wrestler,
    },
  },
  {
    name: STRINGS.navigationItems.aboutUs,
    route: ROUTES.aboutUs,
  },
  /* {
    name: STRINGS.navigationItems.events,
    route: ROUTES.events,
  }, */
  {
    name: STRINGS.navigationItems.training,
    route: ROUTES.training,
  },
  {
    name: STRINGS.navigationItems.supporter,
    route: ROUTES.supporter,
  },
  {
    name: STRINGS.navigationItems.contact,
    route: ROUTES.contact,
  },
]

export const MAIN_ROUTES = NavigationItems.map((item) => item.route).filter(
  (route) => route !== ROUTES.start,
)
